// eslint-disable-next-line import/no-unresolved
import Swiper from "swiper/bundle";

const swipers = [];

document.querySelectorAll(".swiper-pdp-content-carousel")?.forEach((slider) => {
  const sliderSettingsElement = document.querySelector(`[data-id="${slider.id}"]`);
  if (sliderSettingsElement) {
    swipers.push(
      new Swiper(slider, JSON.parse(sliderSettingsElement.textContent)),
    );
  }
});

// eslint-disable-next-line no-console
// console.log(`Initialised ${swipers.length} pdp carousel swipers`, swipers);
